import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UrlTrackerService } from '@app/core/services/url-tracker/url-tracker.service';
import { Location, NgTemplateOutlet } from '@angular/common';
import { Router } from '@angular/router';
import { Ag1TitleComponent } from '../../core/components/ag1-title/ag1-title.component';
import { Bind } from '@openng/optimus-ui/bind';
import { Button } from '@openng/optimus-ui/button';

@Component({
  selector: 'ag-four-oh-four',
  templateUrl: './four-oh-four.component.html',
  styleUrls: ['./four-oh-four.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Ag1TitleComponent, NgTemplateOutlet, Bind, Button],
})
export class FourOhFourComponent {
  private router = inject(Router);
  private location = inject(Location);

  previousUrl: string;

  constructor() {
    const urlTrackerService = inject(UrlTrackerService);

    this.previousUrl = urlTrackerService.previousUrl;
  }

  goBack(): void {
    this.location.back();
  }

  goHome(): void {
    this.router.navigate(['account'], { replaceUrl: true });
  }
}
